<template>
<div
  class='slide slide-audio'
  :class='main_class'
>
  <div
    class='slide-audio_bg'
    :style='background_style'
  />

  <div class='slide_label body-four-light'>
    {{ activity.label || $t('audio') }}
  </div>

  <div class='slide-audio_content'>
    <div class='slide-audio_content-left'>
      <div class='slide-audio_cover'>
        <img
          :src='activity.card_image'
          alt=''
        >
      </div>
    </div>

    <div class='slide-audio_content-right'>
      <h2 class='slide-audio_headline h-two-light'>
        {{ activity.headline }}
      </h2>

      <div class='slide-audio_description body-one-light'>
        {{ activity.subheadline }}
      </div>

      <div
        v-if="activity.links && activity.links.transcript"
        class='slide-audio_transcript body-one-light'
      >
        <a
          :href='activity.links.transcript'
          class='info-action info-action--transcript'
          target='_blank'
          @click='transcriptLinkClick'
        >
          <TranscriptIcon class="info-action_icon" />
          <span class="info-action_title">{{ $t('view_transcript') }}</span>
        </a>
      </div>

      <div class='slide-audio_player'>
        <AudioPlayer
          :file_url='activity.provider_url'
          :should_pause='should_pause'
          :onPlay='onPlay'
          :onComplete='onComplete'
          :onStep='onStep'
          :audio_title='activity.headline'
          :audio_id='activity.id'
          :audio_image='activity.card_image'
        />
      </div>
    </div>
  </div>

  <div
    v-if='has_resources'
    class='slide-audio_resources'
  >
    <ResourcesCarousel
      :resources='slide.resources'
      :show_headline='slide.resource_carousel_headline_visible'
      :pauseMedia='becameHidden'
      context='audio'
      :toggleActivityOverlay='toggleResourceOverlay'
    />
  </div>
</div>
</template>

<script>
import CommonMixin from './common-mixin'
import IconMixin from '../icon-mixin'
import AudioPlayer from 'components/Shared/AudioPlayer/AudioPlayerInline'
import ResourcesCarousel from '../course/resources-carousel'

export default {
  mixins: [CommonMixin, IconMixin],

  data() {
    return {
      should_pause: false,
      completion_fired: false
    }
  },

  components: {
    AudioPlayer,
    ResourcesCarousel
  },

  computed: {
    background_style() {
      if (this.activity.background_image) {
        return `background-image: url(${this.activity.background_image})`
      }

      // Gradient Background
      if (!this.activity.background_image && this.activity.gradient_start) {
        const start = this.activity.gradient_start
        const end = this.activity.gradient_end || this.activity.gradient_start
        const gradient = `linear-gradient(137deg, ${start} 0%, ${end} 92%)`
        return {
          backgroundImage: gradient
        }
      }
      return null
    },

    has_resources() {
      return this.slide && this.slide.resources && this.slide.resources.length
    },

    main_class() {
      const classes = []
      if (this.has_resources) classes.push('has-resources')
      return classes
    },

    has_complete_threshold() {
      return this.activity.complete_threshold &&
             this.activity.complete_threshold > 0
    }
  },

  methods: {
    becameVisible() {
      this.updateResult('viewed')
      this.should_pause = false
    },

    becameHidden() {
      this.should_pause = true
    },

    onPlay() {
      if (!this.has_complete_threshold) {
        this.updateResult('listened')
      }

      dataLayer.push({
        event:        'episodeStart',
        episodeType:  'single',
        episodeTitle: this.activity.headline,
        episodeID:    this.activity.id
      })
    },

    onComplete(audio) {
      this.updateResult('listened')
    },

    onStep(time, duration) {
      if (this.has_complete_threshold && !this.completion_fired) {
        const percent = this.activity.complete_threshold
        const crosstime = Math.floor(duration * (percent * 0.01))

        if (time >= crosstime) {
          this.updateResult('listened')
          this.completion_fired = true
        }
      }
    },

    transcriptLinkClick() {
      if (this.has_complete_threshold) {
        this._updateSlideResult('listened')
      }
    }

  }
}
</script>

<style lang='sass' scoped>
@import './audio-v1'
</style>
